<template>
  <table class="table table-bordered my-3">
    <thead class="thead">
      <tr>
        <th colspan="3">{{ $t('外注工程') }}</th>
        <th>{{ $t('構成部品') }}</th>
        <th>{{ $t('数量') }}</th>
        <th>{{ $t('発注コード') }}</th>
        <th>{{ $t('外注単価') }}</th>
        <th>{{ $t('所要日数') }}</th>
        <th>{{ $t('原価') }}</th>
      </tr>
    </thead>
    <tbody class="tbody">
      <tr>
        <td class="w-5" rowspan="2">
          {{baseProcess.sort}}
        </td>
        <td class="w-10" rowspan="2">
          <template v-if="baseProcess.processKindId">
            {{ $t(mixinProcessKindDisplay(baseProcess.processKindId)) }}
          </template>
          <template v-else>
            -
          </template>
        </td>
        <td class="w-10">
          <template v-if="baseProcess.partnerId">
            {{ baseProcess.partnerName }}
          </template>
          <template v-else>
            -
          </template>
        </td>
        <td rowspan="3" class="p-0 w-19">
          <table class="table mb-0">
            <tbody class="tbody">
              <tr v-for="(item, index) in baseProcess.structures" :key="index" class="bd-top">
                <td>{{ item.productCode }}/{{ item.productName }}</td>
              </tr>
            </tbody>
          </table>
        </td>
        <td rowspan="3" class="p-0 w-5">
          <table class="table mb-0">
            <tbody class="tbody">
              <tr v-for="(item, index) in baseProcess.structures" :key="index" class="bd-top">
                <td>{{ item.quantity }}</td>
              </tr>
            </tbody>
          </table>
        </td>
        <td class="w-12">
          <template v-if="baseProcess.orderCode">
            {{ baseProcess.orderCode }}
          </template>
          <template v-else>
            -
          </template>
        </td>
        <td class="w-12">
          <template v-if="baseProcess.purchasePrice">
            {{ baseProcess.purchasePrice | mixinCommaDisplay }}&nbsp;{{ $t('円') }}
          </template>
          <template v-else>
            -
          </template>
        </td>
        <td class="w-12">
          <template v-if="baseProcess.leadTime">
            {{ baseProcess.leadTime }}&nbsp;{{ $t('日') }}
          </template>
          <template v-else>
            -
          </template>
        </td>
        <td rowspan="2" class="w-15">
          {{ cost | mixinCommaDisplay }}&nbsp;{{ $t('円') }}
        </td>
      </tr>
      <tr>
        <td class="w-10">
          <template v-if="baseProcess.destId">
            {{ baseProcess.destName }}
          </template>
          <template v-else>
            -
          </template>
        </td>
        <td colspan="3" class="w-36 text-break">
          <template v-if="baseProcess.note">
            {{ baseProcess.note }}
          </template>
          <template v-else>
            -
          </template>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    baseProcess: {
      tupe: Object,
      default: () => {},
    },
    processKinds: {
      type: Array,
      default: () => [],
    },
    structures: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      orderingContacts: [],
      OrderingContactsName: '',
      structureCost: 0,
      InHouseCost: 0,
    }
  },
  created() {
  },
  methods: {
    // 工程区分のモーダルを表示
    processKindsModalOpen() {
      this.$emit('processKindsModalOpen')
    },
    // 標準工程をコピー
    copyProcess() {
      this.$emit('copyProcess')
    },
    // 標準工程を挿入
    insertProcess() {
      this.$emit('insertProcess')
    },
    // ソートを変更する処理
    changeSort(direction) {
      this.$emit('changeSort', { sort: this.baseProcess.sort, direction: direction })
    },
    // 値を変更する処理
    changeValue(e, key, type) {
      this.$emit('changeValue', { value: e.target.value, key: key, type: type })
    },
    // 構成部品の合計原価を親コンポーネントのdataに足す
    addStructureCost() {
      this.$parent.structureCost += this.structureCost
    },
    // 社内工程の原価を親コンポーネントのdataに足す
    addInHouseCost() {
      this.$parent.InHouseCost += this.InHouseCost
    },
  },
  computed: {
    cost() {
      let structureCost = 0
      this.baseProcess.structures.map(item => {
        if (item.purchasePrice && this.isNumber(item.purchasePrice)
          && item.quantity && this.isNumber(item.quantity)) {
          structureCost += (item.purchasePrice * item.quantity)
        }
      })
      // FIXME: computedの中でdataに代入すべきではない
      this.structureCost = structureCost // eslint-disable-line vue/no-side-effects-in-computed-properties
      let unitPrice = 0
      if (this.baseProcess
        && this.baseProcess.purchasePrice
        && this.isNumber(this.baseProcess.purchasePrice)) unitPrice = this.baseProcess.purchasePrice

      return (structureCost + unitPrice)
    },
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
  },
  watch: {
    'structureCost': function() {
      this.$emit('addStructureCost')
    },
  },
}
</script>

<style>

</style>
